"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setAddinObserverLoaded_1 = require("../actions/setAddinObserverLoaded");
var store_1 = require("../store/store");
var owa_addins_core_1 = require("owa-addins-core");
var addinCommandSurfaceActionsObserver;
owa_addins_core_1.lazyAddinCommandSurfaceActionsObserver.import().then(function (addinObserver) {
    // Framework team has plans to implement a .isLoaded property for lazy imports.
    // This will allow a component to re-render when the import finishes. Until this is available,
    // we'll use our own boolean in the store. WI: 23555
    addinCommandSurfaceActionsObserver = addinObserver;
    setAddinObserverLoaded_1.default();
});
function getAddinCollection(mode) {
    if (store_1.default.isAddinObserverLoaded && addinCommandSurfaceActionsObserver) {
        return addinCommandSurfaceActionsObserver(mode).get();
    }
    else {
        return null;
    }
}
exports.default = getAddinCollection;
//# sourceMappingURL=getAddinCollection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/utils/getAddinCollection.js
// module id = 2798
// module chunks = 2 3 4